var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 17,
    height: 15,
    rx: 5,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(-2757 -22881)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 24,
    height: 24,
    transform: "translate(2757 22881)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(2761 22886)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M0,5.086V3.716A7.374,7.374,0,0,1,.358,2.187,3.854,3.854,0,0,1,4.129,0h.627A4.012,4.012,0,0,1,8,1.446c.474.516.465.516.922.016A4.015,4.015,0,0,1,12.156,0h.617a3.968,3.968,0,0,1,4.158,3.33,7.574,7.574,0,0,1-3.023,7.2q-2.434,1.974-4.761,4.072c-.583.525-.782.521-1.38-.018-1.519-1.375-3.1-2.681-4.666-4.005A12.839,12.839,0,0,1,1.11,8.5,5.054,5.054,0,0,1,.058,5.412C.058,5.3.09,5.183,0,5.086Z",
    fill: "#46324e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/icon-like.5df86ffb54771155efd0cc813253265c.svg";
export { ForwardRef as ReactComponent };